module.exports = __webpack_public_path__ + "static/media/mainChart2Descr2.58a91c28.png";